export const queryKeys = {
    grocery: 'groceries',
    groceryAutocomplete: 'groceries-autocomplete',
    familyGroup: 'family-group',
    user: 'users',
    userRecipe: 'user-recipes',
    recipes: 'recipes',
    analytics: 'analytics',
    foodsAutocomplete: 'foods-autocomplete',
    nutrients: 'nutrients',
    nutrientsMetadata: 'nutrients-metadata',
    dishNutrients: 'dish-nutrients',
    foodProductNutrients: 'food-product-nutrients',
    meals: 'meals',
    mealDetails: 'meal-details',
    mealTemplates: 'meal-templates',
    nutritionSummary: 'nutrition-summary',
    productByBarcode: 'product-by-barcode',
}
